import React, { useState, useContext } from 'react';
import InputField from '../components/InputField';
import { ThemeContext } from '../theme';

const ILLUS_URL = 'https://res.cloudinary.com/dcnujnpbm/image/upload/q_auto/f_auto/v1776961695/onboarding_image_1_muilsk.webp';

export default function LoginScreen({ onLogin, onSignup }) {
  const theme = useContext(ThemeContext);
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');

  return (
    <div style={{ flex: 1, alignSelf: 'stretch', display: 'flex', backgroundColor: theme.bgPrimary }}>
      <style>{`
        @keyframes loginImgScaleIn {
          from { transform: scale(1.2); }
          to   { transform: scale(1); }
        }
      `}</style>

      {/* Left panel — illustration */}
      <div style={{ width: '38%', flexShrink: 0, position: 'relative', overflow: 'hidden', backgroundColor: theme.cardBg100 }}>
        <img
          src={ILLUS_URL}
          alt=""
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top', animation: 'loginImgScaleIn 0.6s ease-out both' }}
        />
      </div>

      {/* Right panel */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px 104px',
          overflowY: 'auto',
          backgroundColor: theme.cardBg,
        }}
      >
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 32, zoom: 0.9 }}>

          {/* Title */}
          <h1
            className="font-bogart"
            style={{ fontSize: 36, fontWeight: 700, lineHeight: '44px', color: theme.text100, margin: 0 }}
          >
            Welcome Back!
          </h1>

          {/* Fields */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <InputField
              label="E-mail"
              required
              type="email"
              placeholder="eda_yildiz@gmail.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              scale={0.75}
            />
            <InputField
              label="Password"
              required
              type="password"
              placeholder="••••••••••••••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              hint="Password Suggestions"
              scale={0.75}
            />
          </div>

          {/* Actions */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 48 }}>
            <button
              onClick={onLogin}
              className="font-satoshi font-bold"
              style={{
                width: '100%',
                padding: '15px',
                borderRadius: 15,
                border: 'none',
                backgroundColor: theme.btnPrimaryBg,
                color: theme.btnPrimaryText,
                fontSize: 14,
                lineHeight: '18px',
                cursor: 'pointer',
                transition: 'background-color 0.15s',
              }}
            >
              Log in
            </button>

            <p className="font-satoshi" style={{ margin: 0, textAlign: 'center', fontSize: 14, lineHeight: '18px', color: theme.text100 }}>
              Don't have an account?{' '}
              <button
                onClick={onSignup}
                className="font-satoshi font-bold"
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  fontWeight: 700,
                  fontSize: 14,
                  color: theme.text100,
                  padding: 0,
                }}
              >
                Sign up
              </button>
            </p>
          </div>

        </div>
      </div>

    </div>
  );
}
